module.exports = __webpack_public_path__ + "icon-3.svg?9bf4d3f7c601cc1238280814d86fabbc";